import { useRouter } from 'next/router';
import useOnMount from './useOnMount';
import { parseQueryString } from '@/utils/url';

const useRemoveQueryParam = (paramsToRemove: string[], replaceHistory?: boolean) => {
  const { push, replace } = useRouter();
  useOnMount(() => {
    const query = parseQueryString(window.location.search);
    paramsToRemove.forEach((param) => {
      delete query[param];
    });

    if (replaceHistory) {
      replace(
        {
          pathname: window.location.pathname,
          query,
        },
        '',
        { shallow: true },
      );
      return;
    }
    push(
      {
        pathname: window.location.pathname,
        query,
      },
      '',
      { shallow: true },
    );
  });
};

export default useRemoveQueryParam;
